import { CompanySettings } from '../types/hr';

/**
 * Calculates the number of working days between two dates, excluding weekends and company holidays.
 * @param startDateStr Start date string in YYYY-MM-DD format
 * @param endDateStr End date string in YYYY-MM-DD format
 * @param companySettings The global company settings containing weekends off and holidays
 * @returns The total number of working days
 */
export const calculateLeaveDays = (
  startDateStr: string,
  endDateStr: string,
  companySettings: CompanySettings | undefined
): number => {
  if (!startDateStr || !endDateStr) return 0;
  
  const startDate = new Date(startDateStr);
  const endDate = new Date(endDateStr);
  
  if (isNaN(startDate.getTime()) || isNaN(endDate.getTime())) return 0;
  if (startDate > endDate) return 0;

  // Defaults if no settings
  const weekendsOff = companySettings?.weekends_off || [];
  const holidays = (companySettings?.company_holidays || []).map(h => h.date);
  
  const dayNames = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

  let workingDays = 0;
  let currentDate = new Date(startDate);

  while (currentDate <= endDate) {
    const dayName = dayNames[currentDate.getDay()];
    const dateStr = currentDate.toISOString().split('T')[0];

    const isWeekend = weekendsOff.includes(dayName);
    const isHoliday = holidays.includes(dateStr);

    if (!isWeekend && !isHoliday) {
      workingDays++;
    }

    // Move to next day
    currentDate.setDate(currentDate.getDate() + 1);
  }

  return workingDays;
};
